module.exports = __webpack_public_path__ + "e2fe4789272c8806a8edf81f697c0abd.mp4";